import React from 'react';

export const TermsOfService: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <div className="bg-white border-b border-gray-200">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-16">
            <h1 className="text-xl font-semibold text-gray-900">Terms of Service</h1>
          </div>
        </div>
      </div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="prose prose-blue max-w-none">
          <p className="text-sm text-gray-500">Last updated: October 19, 2025</p>

          <h2>Agreement to Terms</h2>
          <p>
            By accessing or using How I Met Your Mortgage (the "Service"), you agree to be bound by these
            Terms. If you do not agree, do not use the Service.
          </p>

          <h2>Use of the Service</h2>
          <ul>
            <li>You must be at least 13 years old to use the Service.</li>
            <li>You are responsible for your account and for maintaining its security.</li>
            <li>You agree not to misuse the Service or attempt to disrupt it.</li>
          </ul>

          <h2>Premium Subscriptions</h2>
          <p>
            Certain features are available only to subscribers. Subscription billing and payment are handled
            by our payment processor. Subscriptions renew automatically unless cancelled in accordance with
            the processor's terms. We may change plan features and pricing with prior notice.
          </p>

          <h2>Intellectual Property</h2>
          <p>
            The Service and its original content, features, and functionality are owned by How I Met Your
            Mortgage and are protected by intellectual property laws. You may not copy, modify, or create
            derivative works without permission.
          </p>

          <h2>Disclaimer</h2>
          <p>
            The Service provides educational tools and information only and does not constitute financial,
            legal, or tax advice. You should consult qualified professionals for advice tailored to your
            situation. Use the Service at your own risk.
          </p>

          <h2>Limitation of Liability</h2>
          <p>
            To the maximum extent permitted by law, we are not liable for any indirect, incidental, special,
            consequential, or punitive damages, or any loss of profits or revenues, whether incurred directly
            or indirectly, or any loss of data, use, goodwill, or other intangible losses.
          </p>

          <h2>Termination</h2>
          <p>
            We may suspend or terminate your access to the Service at any time for conduct that we believe
            violates these Terms or is otherwise harmful to other users or the Service.
          </p>

          <h2>Changes to Terms</h2>
          <p>
            We may modify these Terms from time to time. We will indicate the date of the latest revision at
            the top of this page. Continued use of the Service after changes take effect constitutes
            acceptance of the revised Terms.
          </p>

          <h2>Contact</h2>
          <p>
            Questions about these Terms? Contact us at
            <a href="mailto:support@howimetyourmortgage.com"> support@howimetyourmortgage.com</a>.
          </p>
        </div>
      </div>
    </div>
  );
};

export default TermsOfService;


